import { useMutation } from "@tanstack/react-query";
import { useAxios } from "../../network";

export function useRefreshSession() {
  const axios = useAxios();
  return useMutation(async () => {
    await axios.post("/v1/session/refresh");
  });
}
